import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { getComponentFromSource } from 'src/app/generics-helper/getComponentFromSource.generic';
import { ComponentNames } from 'src/app/helper/componentNames';
import { InputHelper } from 'src/app/helper/inputHelper';
import { AdjustableSeatComponent } from 'src/app/models/components/objectComponents/AdjustableSeatComponent';
import { SeatComponent } from 'src/app/models/components/objectComponents/SeatComponent';
import { BaseAdvancedPropertyViewComponent } from '../base-advanced-property-view.component';

@Component({
  selector: 'app-ptseat',
  templateUrl: './ptseat.component.html',
  styleUrls: ['./ptseat.component.scss']
})
export class PTseatViewComponent extends BaseAdvancedPropertyViewComponent {
  seat: SeatComponent = new SeatComponent();
  adjustableSeat: AdjustableSeatComponent = new AdjustableSeatComponent();
  seatCapacities: number[] = [1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6];
  integerOnly = InputHelper.integerOnly;

  constructor(public dialogRef: MatDialogRef<BaseAdvancedPropertyViewComponent>) {
    super(dialogRef);
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.seat = getComponentFromSource(ComponentNames.seatComponent, this.items);
    this.adjustableSeat = getComponentFromSource(ComponentNames.adjustableSeatComponent, this.items);
  }

  changeSeatCapacity(selectedValue: number) {
    this.seat.seatAmount = selectedValue;
  };

  saveButtonDisabledState(): boolean {
    return false;
  }
}
